import { createContext, useContext } from 'react';

// The video's subtitles and subtitle-free annotations on the annotate page,
// so time controls can find "the next subtitle" (src/utils/timeline.js).
const TimelineContext = createContext({ subtitles: [], annotations: [] });

export const TimelineProvider = TimelineContext.Provider;
export const useTimeline = () => useContext(TimelineContext);
